import { serverTimestamp, FieldValue } from 'firebase/firestore';

export interface TimestampData {
  createdAt: string;
  updatedAt: string;
}

export interface CreatedTimestampData {
  createdAt: string;
}

export interface UpdatedTimestampData {
  updatedAt: string;
  lastUpdated: string;
}

export interface FirestoreTimestampData {
  createdAt: FieldValue;
  updatedAt: FieldValue;
}

export const getTimestamps = (): TimestampData => {
  const now = new Date().toISOString();
  return {
    createdAt: now,
    updatedAt: now
  };
};

export const getCreatedTimestamp = (): CreatedTimestampData => ({
  createdAt: new Date().toISOString()
});

export const getUpdatedTimestamp = (): UpdatedTimestampData => {
  const now = new Date().toISOString();
  return {
    updatedAt: now,
    lastUpdated: now
  };
};

export const getFirestoreTimestamps = (): FirestoreTimestampData => ({
  createdAt: serverTimestamp(),
  updatedAt: serverTimestamp()
});

export const getCurrentISOTimestamp = (): string => new Date().toISOString();

export const getCurrentTimestamp = (): number => Date.now();

export const createTimestampedData = <T extends object>(data: T): T & TimestampData => ({
  ...data,
  ...getTimestamps()
});

export const updateWithTimestamp = <T extends object>(data: T): T & UpdatedTimestampData => ({
  ...data,
  ...getUpdatedTimestamp()
});
